import { mappedFilters } from '../sitemap/constants/sitemapConstants';

export function getFilterType(filterType = '') {
    return mappedFilters[filterType] || filterType;
}
// This helper cheks for uri segment of filter type
export function getFilterUriType(filterType = '') {
    return Object.keys(mappedFilters).reduce((acc, key) => {
        if (mappedFilters[key] === filterType) {
            acc = key;
        }
        return acc;
    }, filterType);
}
